export default "__VITE_ASSET__DWP9mH$4__"